import React from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import RecommendationDataTable from './recommendationDataTable';
import Header from '../../components/header';

const Recommendation: React.FC = () => {
    return (
        <div className="flex">
            <SideMenuBar sideMenuBarClass={'w-64 h-screen w-1/6 bg-white '} />

            <div className="w-full h-screen w-5/6 bg-sky-50 overflow-y-auto" style={{ maxHeight: '100vh' }}>
                <Header />
                <div className="p-8">
                    <h1 className="text-xl font-semibold text-gray-600 mb-2">Recommendation</h1>

                    {/* Paragraph */}
                    <p className="text-sm text-gray-400 mb-6">
                        Actionable business recommendations driven by sentiment and topic analysis.
                    </p>
                    <div className='mb-5'>
                        {/* Card Component */}
                        <div className="bg-white shadow-lg rounded-2xl p-6 mb-5 h-screen overflow-auto">
                            <RecommendationDataTable filterValue={{}} />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default Recommendation;